import { DollarSign } from '@tamagui/lucide-icons';
import { ErrorMessage } from '@unistocks/components/error-message/error-message';
import { Loader } from '@unistocks/components/loading/spinner/loader';
import { QueryState } from '@unistocks/components/query-state/query-state';
import {
  DashboardItemFrame,
  DashboardItemProps
} from '@unistocks/features/dashboard/components/dashboard-item/dashboard-item';
import { DashboardItemHeader } from '@unistocks/features/dashboard/components/dashboard-item/dashboard-item-header';
import { t } from '@unistocks/localization';
import { DashboardItemType } from '@unistocks/proxy/axios-client';
import {
  dashboardGetNetSavingsDataQueryKey,
  useDashboardGetNetSavingsDataQuery
} from '@unistocks/proxy/axios-client/DashboardQuery';
import React from 'react';

const PortfolioNetSavingsChart = React.lazy(
  () => import('@unistocks/features/portfolios/components/charts/net-savings/net-savings-chart')
);

export const NetSavings: React.FC<DashboardItemProps> = ({ item, openSettings, ...frameProps }) => {
  const { id, settings } = item;
  const { data, isSuccess } = useDashboardGetNetSavingsDataQuery({
    id
  });

  const title =
    settings.title?.trim() || t(`::Enum:DashboardItemType:${DashboardItemType.NetSavings}`);

  return (
    <DashboardItemFrame {...frameProps}>
      <DashboardItemHeader item={item} title={title} openSettings={openSettings} />
      <QueryState
        queryKeys={[dashboardGetNetSavingsDataQueryKey(id)]}
        size={'$5'}
        flex={1}
        py={0}
        renderLoading={<NetSavingsLoader />}
        renderError={({ error, onRetry }) => <ErrorMessage error={error} onRetry={onRetry} />}
        isEmpty={isSuccess && !data.withdrawals && !data.deposits}
        noDataIcon={DollarSign}
        noDataText={t('::Portfolio:BarChart:NoData')}
      >
        {isSuccess ? (
          <React.Suspense fallback={<NetSavingsLoader />}>
            <PortfolioNetSavingsChart
              {...data}
              period={settings.period!}
              containerProps={{ '$platform-web': { flex: 1 } }}
              chartContainerProps={{ h: '$20', '$platform-web': { flex: 1 } }}
            />
          </React.Suspense>
        ) : null}
      </QueryState>
    </DashboardItemFrame>
  );
};

const NetSavingsLoader = () => (
  <Loader size={'$5'} textProps={{ size: '$6' }}>
    {t('AbpUi::LoadingWithThreeDot')}
  </Loader>
);
